import { Theme } from '../material';

export const getScrollbarColors = (theme: Theme) => {
  const trackColor = theme.palette.background.paper;

  const thumbColor = theme.palette.elevation[12].background;

  return { trackColor, thumbColor };
};
